/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandStrava = createReactComponent("brand-strava", "IconBrandStrava", [
  ["path", { d: "M15 13l-5 -10l-5 10m6 0l4 8l4 -8", key: "svg-0" }]
]);

export { IconBrandStrava as default };
//# sourceMappingURL=IconBrandStrava.js.map
